import { defineMessages } from 'react-intl.macro';
import { HarvestStatesEnum } from '../../openapi/types/HarvestStatesEnum';

export const datasourceStateMessages = defineMessages<HarvestStatesEnum | 'null'>({
  null: {
    id: 'datasource.state.null',
    defaultMessage: 'Nespuštěno',
  },
  [HarvestStatesEnum.WAITING_FOR_PROCESSING]: {
    id: 'datasource.state.WAITING_FOR_PROCESSING',
    defaultMessage: 'Čeká na zpracování',
  },
  [HarvestStatesEnum.PROCESSING]: {
    id: 'datasource.state.PROCESSING',
    defaultMessage: 'Probíhá aktualizace',
  },
  [HarvestStatesEnum.PROCESSED]: {
    id: 'datasource.state.PROCESSED',
    defaultMessage: 'Aktualizováno',
  },
  [HarvestStatesEnum.FAILED]: {
    id: 'datasource.state.FAILED',
    defaultMessage: 'Aktualizace selhala',
  },
});

export const datasourceMessages = defineMessages({
  datasourceListPageTitle: {
    id: 'datasourceList.PageTitle',
    defaultMessage: 'Přehled datových zdrojů',
  },
  datasourceListStateWaiting: {
    id: 'datasourceList.state.waiting',
    defaultMessage: 'Seznam datových zdrojů se načítá.',
  },
  datasourceListStateFail: {
    id: 'datasourceList.state.fail',
    defaultMessage: 'Seznam datových zdrojů se nepovedlo načíst.',
  },
  name: {
    id: 'datasourceList.name',
    defaultMessage: 'Název',
  },
  harvested: {
    // - casove razitko
    id: 'datasourceList.harvested',
    defaultMessage: 'Aktualizováno',
  },
  state: {
    // - vyjmenovane stavy - string (waiting_for_processing,.... ???)
    id: 'datasourceList.state',
    defaultMessage: 'Stav',
  },
  created: {
    id: 'datasourceList.created',
    defaultMessage: 'Vytvořeno',
  },
  edited: {
    id: 'datasourceList.edited',
    defaultMessage: 'Editováno',
  },
  harvest: {
    id: 'datasourceList.harvest',
    defaultMessage: 'Aktualizovat',
  },
  datasetsCount: {
    id: 'datasourceList.datasetsCount',
    defaultMessage: 'Počet datových sad',
  },
  harvestFail: {
    id: 'datasourceList.harvestFail',
    defaultMessage: 'Aktualizaci datového zdroje se nepodařilo spustit.',
  },
  harvestStuck: {
    id: 'datasourceList.harvestStuck',
    defaultMessage:
      'Stav se nezměnil déle než {minutes} minut, aktualizace nejspíš uvízla. Datový zdroj musí odblokovat správce.',
  },
});
